import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang, translations } from '../i18n';
import LanguageDropdownCompact from '../components/LanguageDropdownCompact';
import './Login.css';

const API_FORGOT_PASSWORD_1 = process.env.REACT_APP_API_USERS + "/forgot-password-1" || '';

const ForgotPassword1: React.FC = () => {
  const { lang } = useLang();
  const t = translations[lang];
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await fetch(API_FORGOT_PASSWORD_1, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l\'envoi du code');
      }

      // Si succès, afficher le message et rediriger vers l'étape 2
      setSuccess(t.forgotPasswordEmailSuccess);
      
      // Rediriger après 2 secondes en passant l'email en state
      setTimeout(() => {
        navigate('/forgot-password-2', { state: { email } });
      }, 2000);

    } catch (err) {
      setError(t.forgotPasswordEmailError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <div style={{display:'flex',justifyContent:'center',marginBottom:24,position:'relative'}}>
          <img src={process.env.PUBLIC_URL + '/recat-logo-1024.png'} alt="Logo" style={{height:80}} />
          <div style={{position:'absolute',right:0,top:0}}>
            <LanguageDropdownCompact />
          </div>
        </div>
        
        <h2>{t.forgotPasswordTitle}</h2>
        <p style={{ margin: '0 0 10px 0', color: '#666', textAlign: 'center', fontSize: '0.95rem' }}>
          {t.forgotPasswordEmailLabel}
        </p>

        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t.forgotPasswordEmailPlaceholder}
          required
          disabled={loading}
        />

        {error && <div className="login-error">{error}</div>}
        {success && <div style={{ color: '#2aa04aff', background: '#e8f5e9', borderRadius: '6px', padding: '8px 10px', textAlign: 'center', fontSize: '0.98rem' }}>{success}</div>}

        <button type="submit" disabled={loading || !email}>
          {loading ? t.forgotPasswordEmailLoading : t.forgotPasswordEmailBtn}
        </button>

        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <a href="/login" style={{ color: '#2aa04aff', textDecoration: 'underline', fontSize: '0.95rem' }}>
            {t.loginTitle}
          </a>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword1;
